import Swal, { SweetAlertType } from 'sweetalert2';

export class CommandResult {

    constructor(
        public success: boolean,
        public message: string,
        public notifications: any[],
        public data: any
    ) { }


    public showError(tipo: SweetAlertType = 'error') {

        let erros = '';
        this.notifications.forEach(n => erros += `<br />${n.message}`);

        if (this.success === false) {
            Swal({
                title: '',
                html: `${erros}`,
                type: tipo,
            });
        }

    }

    public showWarning() {
        this.showError('warning');
    }


    public showSucess() {
        if (this.success === true) {
            Swal({
                title: '',
                html: `<b>${this.message}</b>`,
                type: 'success',
            });
        }
    }

    public showErrorExecption(exception: any) {

        let msg = exception.message;
        if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
        if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }

        this.message = `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`;
        this.notifications = [];
        this.data = null;

        this.showError();

    }

    public getMessageException(exception: any): string {

        let msg = exception.message;
        if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
        if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }

        const messageException = `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`;
        this.notifications = [];

        return messageException;

    }
}
